module.exports = __webpack_public_path__ + "images/1e21a67fc2e30a1e7429ce840a72c017.svg";